// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 224 ? "baseModule" : chunkId) + "." + {"224":"15e7e520","459":"af36580a","609":"1e7c2fec","728":"841651d0"}[chunkId] + ".css";
};